import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  getAnalyticsSummary,
  type AnalyticsSummary,
  type AnalyticsSummaryParams,
} from "../api/analyticsSummary";

const KEY = "analytics-summary";

/** Admin Analytics dashboard. `keepPreviousData` so the page doesn't blank
 *  out while the user changes the days / responsibility filter. */
export function useAnalyticsSummary(params: AnalyticsSummaryParams = {}) {
  return useQuery<AnalyticsSummary>({
    queryKey: [KEY, params],
    queryFn: () => getAnalyticsSummary(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
